import React from 'react';
import { preloader } from '../img';
import styled from 'styled-components';

function format(t) {
  let hs = Math.round((t % 1000) / 10);
  let s = Math.floor((t / 1000) % 60);
  let m = Math.floor(t / (60 * 1000));
  return `${m}:${s < 10 ? '0' : ''}${s}:${hs < 10 ? '0' : ''}${hs}`;
}

export default function Thanks(props) {
  let topList = props.topList;
  return (
    <Wrap>
      {topList.map(({ name, value }, i) => (
        <div key={i}>
          <span>{name}</span>
          <strong>{format(value)}</strong>
        </div>
      ))}
    </Wrap>
  );
}

const Wrap = styled.div`
  background: url('${() =>
    preloader.get(require('../img/toplist.png'))}') no-repeat 0 0;
  color: #57463C;
  text-transform: uppercase;
  padding-top: 500px;

  div {
    display: flex;
    width: 100%;
    font-size: 60px;
    font-family: regularfont;
    border: 5px solid #57463C;
    margin: 20px auto;
    padding: 20px;
    width: 750px;
  }

  strong {
    font-family: boldfont;
  }

  span {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 20px;
  }
`;
